"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asEditableBV = exports.editButtonOptions = void 0;

var react_1 = __importDefault(require("react"));

var core_1 = require("@bodiless/core");

var lodash_1 = require("lodash");

var asBodilessBV_1 = require("./asBodilessBV"); // Options used to create an edit button.


exports.editButtonOptions = {
  icon: 'settings',
  label: 'Settings',
  groupLabel: 'Reviews',
  name: 'Edit',
  renderForm: function renderForm(_a) {
    var formUi = _a.ui;

    var _b = core_1.getUI(formUi),
        ComponentFormTitle = _b.ComponentFormTitle,
        ComponentFormLabel = _b.ComponentFormLabel,
        ComponentFormText = _b.ComponentFormText;

    return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(ComponentFormTitle, null, "Bazaarvoice"), react_1.default.createElement(ComponentFormLabel, {
      htmlFor: "bv-product-id"
    }, "BV Product External ID"), react_1.default.createElement(ComponentFormText, {
      field: "productId",
      id: "bv-product-id"
    }));
  },
  global: false,
  local: true
};
exports.asEditableBV = lodash_1.flowRight(asBodilessBV_1.withBVDataHandlers, core_1.ifEditable(core_1.withEditButton(exports.editButtonOptions), core_1.withContextActivator('onClick'), core_1.withLocalContextMenu), core_1.withData);